import { combineReducers, createStore, applyMiddleware } from "redux";
import subscribeActionMiddleware from "redux-subscribe-action";
import UserReducer from "./modules/user/reducer";
import NotificationReducer from "./modules/notification/reducer";

const allReducers = combineReducers({
  user: UserReducer,
  notifications: NotificationReducer,
});

const store = createStore(
  allReducers,
  applyMiddleware(subscribeActionMiddleware)
);
export default store;
